import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import tokens from "../_tokens"
import Caption from "./caption"

const Grid = styled.div`
  display: grid;
  margin-bottom: ${1.5 * tokens.size.base}px;
  grid-template-columns: 1fr;
  grid-gap: ${1.5 * tokens.size.base}px;

  @media screen and (min-width: ${tokens.breakpoint.l}px) {
    grid-template-columns: 1fr 1fr;
  }
`

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const HeadingContainer = styled.div`
  margin-bottom: 8px;
  display: flex;
  align-self: start;
  align-items: center;
`

const IconContainer = styled.div`
  display: flex;
  color: #fff;
  padding: 4px;
  border-radius: 50%;
`

const Text = styled.span`
  font-weight: 600;
  margin-left: ${0.5 * tokens.size.base}px;
  color: ${tokens.color.bgDark};
`
export function DoDontContainer({ children }) {
  return <Grid>{children}</Grid>
}

DoDontContainer.propTypes = {
  children: PropTypes.node,
}

export function Do(props) {
  return (
    <DoDontBase
      {...props}
      text="Do"
      icon={() => (
        <span
          style={{
            lineHeight: tokens.size.base + "px",
            height: tokens.size.base + "px",
            width: tokens.size.base + "px",
            fontSize: tokens.size.base + "px",
            textAlign: "center",
          }}
        >
          ✓
        </span>
      )}
      iconBg={tokens.color.success}
    />
  )
}

export function Dont(props) {
  return (
    <DoDontBase
      {...props}
      text="Don't"
      icon={() => (
        <span
          style={{
            lineHeight: tokens.size.base + "px",
            height: tokens.size.base + "px",
            width: tokens.size.base + "px",
            fontSize: tokens.size.base + "px",
            textAlign: "center",
          }}
        >
          ✕
        </span>
      )}
      iconBg={tokens.color.error}
    />
  )
}

function DoDontBase({ src, alt, children, text, icon: Icon, iconBg }) {
  return (
    <FlexContainer>
      <HeadingContainer>
        <IconContainer style={{ background: iconBg }}>
          <Icon />
        </IconContainer>
        <Text>{text}</Text>
      </HeadingContainer>
      <img src={src} alt={alt} width="100%" />
      <Caption mb={0}>{children}</Caption>
    </FlexContainer>
  )
}

DoDontBase.propTypes = {
  alt: PropTypes.string,
  children: PropTypes.any,
  icon: PropTypes.any,
  iconBg: PropTypes.any,
  src: PropTypes.any,
  text: PropTypes.any,
}

DoDontBase.defaultProps = {
  alt: "",
}
